
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'ImageSlider',
  components: {
    Swiper,
    SwiperSlide,
  },

  inject: ['blueprint'],

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  data() {
    const needsLoop = this.blueprint !== 'home_page'
    console.log(needsLoop)
    return {
      swiperOption: {
        slidesPerView: 1.3,
        spaceBetween: 30,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        grabCursor: true,
        loop: needsLoop,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true,
        },

        breakpoints: {
          1500: {
            slidesPerView: 3.3,
            slidesOffsetBefore: 160,
          },

          1200: {
            slidesPerView: 3.3,
            slidesOffsetBefore: 16,
          },

          640: {
            slidesPerView: 2.3,
          },
        },

        navigation: {
          nextEl: '.custom-button-next',
          prevEl: '.custom-button-prev',
        },
      },
    }
  },
}
